export const COUPON_ADMIN_COLUMNS = [
     {
          key: 'code',
          label: 'Code',
          _style: { minWidth: '190px' },
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '100px' },
          filter: false,
     },
     {
          key: 'discountType',
          label: 'Discount Type',
          _style: { minWidth: '130px' },
          filter: false,
     },
     {
          key: 'type',
          label: 'Coupon Type',
          _style: { minWidth: '160px' },
          filter: false,
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '100px' },
          filter: false,
     },
     {
          key: 'startAt',
          label: 'Start Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'endAt',
          label: 'End Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '125px' },
     },
     {
          key: 'updatedAt',
          label: 'Last modified',
          _style: { minWidth: '125px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { width: '130px' },
     },
];

export const CONTENT_MANAGEMENTS_ADMIN_COLUMN = [
     {
          key: 'key',
          label: 'Key',
          _style: { minWidth: '150px' },
     },
     {
          key: 'value',
          label: 'Value',
          _style: { minWidth: '150px' },
     },
     {
          key: 'type',
          label: 'Type',
          _style: { minWidth: '150px' },
     },
     {
          key: 'category',
          label: 'Category',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const CEPACK_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'numberOfCeEarned',
          label: 'Number of CE Earned',
          _style: { minWidth: '200px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '110px' },
     },
];

export const CERTIFICATE_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'layout',
          label: 'Layout',
          _style: { minWidth: '155px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '110px' },
     },
];

export const DESIGNATION_ELEMENT_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '200px' },
     },
     {
          key: 'requirementCertificationLevels',
          label: 'Requirement Certification Levels',
          _style: { minWidth: '200px' },
     },
     {
          key: 'requirementType',
          label: 'Requirement Type',
          _style: { minWidth: '200px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '120px' },
     },
     {
          key: 'order',
          label: 'Order',
          _style: { minWidth: '120px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '120px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { width: '110px' },
     },
];

export const INSTRUCTOR_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'title',
          label: 'Title',
          _style: { minWidth: '155px' },
     },

     {
          key: 'description',
          label: 'Description',
          _style: { minWidth: '250px' },
     },
     {
          key: 'image',
          label: 'Image',
          _style: { minWidth: '210px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const LESSON_ADMIN_COLUMNS = [
     {
          key: 'description',
          label: 'Lesson Description',
          _style: { minWidth: '250px' },
     },
     {
          key: 'shortDescription',
          label: 'Lesson Content',
          _style: { minWidth: '190px' },
     },
     {
          key: 'video',
          label: 'Video Embed or Video Link',
          _style: { minWidth: '200px' },
     },
     {
          key: 'completionThreshold',
          label: 'Completion Threshold (%)',
          _style: { minWidth: '150px' },
     },
     {
          key: 'order',
          label: 'Order',
          _style: { minWidth: '130px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '90px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const LICENSEE_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '200px' },
     },
     {
          key: 'country',
          label: 'Country',
          _style: { minWidth: '300px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '130px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '250px' },
     },
];

export const ORGANIZATION_DETAIL_ADMIN_COLUMNS = [
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '250px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'orgRole',
          label: 'Organization Role',
          _style: { minWidth: '150px' },
     },
];

export const PRODUCT_TYPE_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'trainingProductType',
          label: 'Training Product Type',
          _style: { minWidth: '250px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '120px' },
     },
];

export const QUESTION_ADMIN_COLUMNS = [
     { key: 'id', label: 'ID', _style: { minWidth: '100px' } },
     {
          key: 'question',
          label: 'Question',
          _style: { minWidth: '190px' },
     },
     {
          key: 'type',
          label: 'Type',
          _style: { minWidth: '150px' },
     },
     {
          key: 'order',
          label: 'Order',
          _style: { minWidth: '140px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const SELLING_GROUP_CATEGORIES_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '200px' },
     },
     {
          key: 'slug',
          label: 'Slug',
          _style: { minWidth: '200px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const SELLING_GROUP_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'headline',
          label: 'Headline',
          _style: { minWidth: '155px' },
     },
     {
          key: 'slug',
          label: 'Slug',
          _style: { minWidth: '155px' },
     },
     {
          key: 'packageCheckMark',
          label: 'Package',
          _style: { minWidth: '100px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '120px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const SURVEY_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '250px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { width: '110px' },
     },
];

export const TEST_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'courseAttached',
          label: 'Attached to Course',
          _style: { minWidth: '190px' },
     },
     {
          key: 'completionThreshold',
          label: 'Completion Threshold (%)',
          _style: { minWidth: '230px' },
     },
     {
          key: 'limitAttempts',
          label: 'Limit Attempts',
          _style: { minWidth: '200px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const TRAINING_PRODUCT_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'productType',
          label: 'Product Type',
          _style: { minWidth: '180px' },
     },
     {
          key: 'licensee',
          label: 'Licensee',
          _style: { minWidth: '120px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '100px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const PRODUCT_REVIEW_ADMIN_COLUMNS = [
     {
          key: 'userName',
          label: 'User Name',
          _style: { minWidth: '190px' },
     },
     {
          key: 'subject',
          label: 'Subject',
          _style: { minWidth: '155px' },
     },
     {
          key: 'comment',
          label: 'Comment',
          _style: { minWidth: '250px' },
     },
     {
          key: 'rating',
          label: 'Rating',
          _style: { minWidth: '150px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'enableAt',
          label: 'Enable Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '160px' },
     },
];

export const PRODUCT_MEDIA_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Name',
          _style: { minWidth: '200px' },
     },
     {
          key: 'link',
          label: 'Link',
          _style: { minWidth: 'inherit' },
     },
     {
          key: 'type',
          label: 'Type',
          _style: { minWidth: '200px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: 'inherit' },
     },
     {
          key: 'order',
          label: 'Order',
          _style: { minWidth: '140px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '120px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '120px' },
     },
     {
          key: 'viewDetails',
          label: '',
          _style: { minWidth: '150px' },
          filter: false,
          sorter: false,
     },
];

export const PRODUCT_EVENT_ADMIN_COLUMNS = [
     {
          key: 'selfId',
          label: 'Event ID',
          _style: { minWidth: '90px' },
     },
     {
          key: 'name',
          label: 'Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'startAt',
          label: 'Start Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'purchaser',
          label: 'Purchaser',
          _style: { minWidth: '150px' },
     },
     {
          key: 'organization',
          label: 'Organization',
          _style: { minWidth: '150px' },
     },
     {
          key: 'orderId',
          label: 'Order ID',
          _style: { minWidth: '120px' },
     },
     {
          key: 'orderDate',
          label: 'Order Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '100px' },
     },
     {
          key: 'maxSeats',
          label: 'Max Seats',
          _style: { minWidth: '100px' },
          filter: false,
     },
     {
          key: 'isPrivate',
          label: 'Private',
          _style: { minWidth: '100px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '125px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '125px' },
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '155px' },
     },
];

export const ORDER_STATUS_ADMIN_COLUMNS = [
     {
          id: 'AwaitingPayment',
          name: 'Awaiting Payment',
     },
     {
          id: 'Void',
          name: 'Void',
     },
     {
          id: 'Uncollectible',
          name: 'Uncollectible',
     },
     {
          id: 'Completed',
          name: 'Completed',
     },
     {
          id: 'Canceled',
          name: 'Canceled',
     },
];

export const USER_SURVEY_ADMIN_COLUMNS = [
     {
          key: 'product',
          label: 'Course',
     },
     {
          key: 'name',
          label: 'User',
     },
     {
          key: 'email',
          label: 'Email',
     },
     // {
     //      key: 'event',
     //      label: 'Training Event',
     // },
     {
          key: 'createdAt',
          label: 'Creation Date',
     },
     {
          key: 'timezone',
          label: 'User Time Zone',
     },
     {
          key: 'viewDetails',
          label: '',
     },
];

export const USER_TEST_ADMIN_COLUMNS = [
     {
          key: 'product',
          label: 'Course',
     },
     {
          key: 'name',
          label: 'User',
     },
     {
          key: 'email',
          label: 'Email',
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
     },
     {
          key: 'timezone',
          label: 'User Time Zone',
     },
     {
          key: 'scores',
          label: 'Scores',
     },
     {
          key: 'viewDetails',
          label: '',
     },
];

export const USER_SURVEY_DETAIL_ADMIN_COLUMNS = [
     {
          key: 'question',
          label: 'Question',
          _style: { width: '50%' },
     },
     {
          key: 'answer',
          label: 'Answer',
          _style: { width: '50%' },
     },
];

export const USER_TEST_DETAIL_ADMIN_COLUMNS = [
     {
          key: 'index',
          label: '#',
          filter: false,
          sorter: false,
          _style: { width: '3%' },
     },
     {
          key: 'question',
          label: 'Question',
          filter: false,
          sorter: false,
          _style: { width: '50%' },
     },
     {
          key: 'answer',
          label: 'Answer',
          filter: false,
          sorter: false,
          _style: { width: '45%' },
     },
];

export const PRODUCT_ACCESS_ADMIN_COLUMNS = [
     {
          key: 'productName',
          label: 'Product Name',
          _style: { minWidth: '220px' },
     },
     {
          key: 'methodOfAccess',
          label: 'Method Of Access',
          _style: { width: '200px' },
     },
     {
          key: 'accessedAt',
          label: 'Original Access Date',
          _style: { width: '160px' },
     },
     {
          key: 'expiredAt',
          label: 'Expiration Date',
          _style: { width: '160px' },
     },
     {
          key: 'daysToExpiration',
          label: 'Days to Expiration',
          _style: { width: '150px' },
     },
     {
          key: 'confirmAttended',
          label: 'Confirm Attended',
          _style: { width: '150px' },
     },
     {
          key: 'courseStatus',
          label: 'Status',
          _style: { width: '150px' },
     },
     {
          key: 'options',
          label: '',
          filter: false,
          sorter: false,
          _style: { width: '170px' },
     },
];

export const ORGANIZATION_ACCESS_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Organizations',
          _style: { minWidth: '250px' },
     },
     {
          key: 'licenseeName',
          label: 'Licensee',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
];

export const SURVEY_SECTION_ADMIN_COLUMNS = [
     { key: 'id', label: 'ID', _style: { minWidth: '100px' } },
     {
          key: 'name',
          label: 'Admin Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'title',
          label: 'Title',
          _style: { minWidth: '150px' },
     },
     {
          key: 'description',
          label: 'Description',
          _style: { minWidth: '150px' },
     },
     {
          key: 'order',
          label: 'Order',
          _style: { minWidth: '100px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'options',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const ALTERNATE_EMAIL_ADMIN_COLUMNS = [
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '250px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
];

export const PRODUCT_FAQ_ADMIN_COLUMNS = [
     {
          key: 'question',
          label: 'Question',
          _style: { minWidth: '155px' },
     },
     {
          key: 'answer',
          label: 'Answers',
          _style: { minWidth: '190px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'order',
          label: 'Order',
          _style: { minWidth: '140px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '160px' },
     },
];

export const ORDER_PURCHASES_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          filter: false,
          sorter: false,
          _style: { minWidth: '190px' },
     },
     {
          key: 'price',
          label: 'Price',
          filter: false,
          sorter: false,
          _style: { minWidth: '120px', textAlign: 'center' },
     },
     {
          key: 'quantity',
          label: 'Seats',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px', textAlign: 'center' },
     },
     {
          key: 'total',
          label: 'Total',
          filter: false,
          sorter: false,
          _style: { minWidth: '155px', textAlign: 'center' },
     },
];

export const ANSWER_ADMIN_COLUMNS = [
     { key: 'id', label: 'ID', _style: { minWidth: '190px' } },
     {
          key: 'answer',
          label: 'Answer',
          _style: { minWidth: '190px' },
     },
     {
          key: 'order',
          label: 'Order',
          _style: { minWidth: '120px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px' },
     },
     {
          key: 'isCorrect',
          label: 'Is Correct',
          _style: { minWidth: '150px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '150px' },
     },
     {
          key: 'showDetails',
          label: '',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
     },
];

export const ORDER_DETAILS_ADMIN_COLUMNS = [
     {
          key: 'name',
          label: 'Name',
          filter: false,
          sorter: false,
          _style: { minWidth: '300px' },
     },
     {
          key: 'price',
          label: 'Cost',
          filter: false,
          sorter: false,
          _style: { minWidth: '70px', textAlign: 'center' },
     },
     {
          key: 'quantity',
          label: 'Seats/Qty',
          filter: false,
          sorter: false,
          _style: { minWidth: '60px', textAlign: 'center' },
     },
     {
          key: 'total',
          label: 'Total',
          filter: false,
          sorter: false,
          _style: { minWidth: '70px', textAlign: 'right' },
     },
];

export const ORDER_SEATS_ADMIN_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          filter: false,
          sorter: false,
          _style: { minWidth: '75px', textAlign: 'center' },
     },
     {
          key: 'productName',
          label: 'Product',
          filter: false,
          sorter: false,
          _style: { width: '150px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          filter: false,
          sorter: false,
          _style: { width: '150px', textAlign: 'center' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          filter: false,
          sorter: false,
          _style: { width: '150px', textAlign: 'center' },
     },
     {
          key: 'email',
          label: 'Email',
          filter: false,
          sorter: false,
          _style: { width: '450px', textAlign: 'center' },
     },
     {
          key: 'shippingAddress',
          label: 'Shipping Address',
          filter: false,
          sorter: false,
          _style: { width: '300px', textAlign: 'center' },
     },
     {
          key: 'trackingCode',
          label: 'Tracking Number',
          filter: false,
          sorter: false,
          _style: { minWidth: '200px', textAlign: 'center' },
     },
     {
          key: 'trackingCarrierCode',
          label: 'Tracking Carrier',
          filter: false,
          sorter: false,
          _style: { width: '200px', textAlign: 'center' },
     },
     {
          key: 'shippingStatus',
          label: 'Shipping Status',
          filter: false,
          sorter: false,
          _style: { width: '195px', textAlign: 'center' },
     },
     // {
     //      key: 'options',
     //      label: 'Action',
     //      _style: { minWidth: '160px', textAlign: 'center' },
     //      filter: false,
     //      sorter: false,
     // },
];

export const ORDER_LINKS_ADMIN_COLUMNS = [
     {
          key: 'selfId',
          label: 'ID',
          _style: { width: '95px' },
     },
     {
          key: 'seatCode',
          label: 'Seat ID',
          _style: { width: '95px' },
     },
     {
          key: 'productName',
          label: 'Product',
          _style: { width: '150px' },
     },
     {
          key: 'originalLink',
          label: 'Link',
          _style: { minWidth: '250px' },
     },
     {
          key: 'userFirstName',
          label: 'First Name',
          _style: { minWidth: '100px' },
     },
     {
          key: 'userLastName',
          label: 'Last Name',
          _style: { minWidth: '100px' },
     },
     {
          key: 'userEmail',
          label: 'Email',
          _style: { minWidth: '200px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          filter: false,
          _style: { minWidth: '100px' },
     },
     {
          key: 'options',
          label: 'Action',
          _style: { minWidth: '160px', textAlign: 'center' },
          filter: false,
          sorter: false,
     },
];

export const ORDER_REST_SEATS_ADMIN_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          filter: false,
          sorter: false,
          _style: { width: '75px', textAlign: 'center' },
     },
     {
          key: 'productName',
          label: 'Product',
          filter: false,
          sorter: false,
          _style: { width: '300px' },
     },
     {
          key: 'bundleName',
          label: 'Bundle',
          filter: false,
          sorter: false,
          _style: { width: '150px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          filter: false,
          sorter: false,
          _style: { width: '150px', textAlign: 'center' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          filter: false,
          sorter: false,
          _style: { width: '150px', textAlign: 'center' },
     },
     {
          key: 'email',
          label: 'Email',
          filter: false,
          sorter: false,
          _style: { width: '450px', textAlign: 'center' },
     },
     {
          key: 'status',
          label: 'Status',
          filter: false,
          sorter: false,
          _style: { width: '150px', textAlign: 'center' },
     },
     {
          key: 'options',
          label: 'Action',
          _style: { width: '160px', textAlign: 'center' },
          filter: false,
          sorter: false,
     },
];

export const SEAT_AND_TRAINEE_ADMIN_COLUMNS = [
     {
          key: 'number',
          sorter: false,
          label: '#',
          _style: { width: '80px', textAlign: 'center' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '100px' },
     },
     {
          key: 'organizationName',
          label: 'Owned by Group',
          _style: { minWidth: '170px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '250px' },
     },
     {
          key: 'action',
          label: 'Action',
          sorter: false,
          _style: { minWidth: '100px' },
     },
];

export const SEAT_AND_TRAINEE_SOW_ADMIN_COLUMNS = [
     {
          key: 'number',
          sorter: false,
          label: 'SeatID',
          _style: { width: '80px', textAlign: 'center' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '100px' },
     },
     {
          key: 'organizationName',
          label: 'Owned by Group',
          _style: { minWidth: '170px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '250px' },
     },
     {
          key: 'action',
          label: 'Action',
          sorter: false,
          _style: { minWidth: '100px' },
     },
];

export const ASSIGNED_ORGANIZATIONS_ADMIN_COLUMNS = [
     {
          key: 'number',
          sorter: false,
          label: '#',
          _style: { width: '80px', textAlign: 'center' },
     },
     {
          key: 'status',
          sorter: false,
          label: 'Status',
          _style: { minWidth: '100px' },
     },
     {
          key: 'name',
          label: 'Organization',
          _style: { minWidth: '170px' },
     },
     {
          key: 'owner',
          label: 'Owner',
          _style: { minWidth: '170px' },
     },
     {
          key: 'numberOfSeats',
          label: 'Number Of Seats',
          _style: { minWidth: '80px', textAlign: 'center' },
     },
     {
          key: 'action',
          label: 'Action',
          sorter: false,
          _style: { minWidth: '100px' },
     },
];

export const COUPON_LIST_USES_ADMIN_COLUMNS = [
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '150px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '150px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '150px' },
     },
     {
          key: 'organizationNames',
          label: 'Organization',
          _style: { minWidth: '200px' },
     },
     {
          key: 'selfId',
          label: 'Order',
          sorter: false,
          _style: { minWidth: '100px' },
     },
];
